import * as React from "react";

// NPM
import moment from "moment";

// Classes
import Calendar from "../domain/classes/Calendar";
import DateTime from "../domain/classes/DateTime";
import { useTheme } from "@material-ui/core/styles";
import { useMediaQuery } from "@material-ui/core";
import Utility from "../domain/classes/Utility";

export interface ICalendarContext {
	dateRange: string[];
	handleDateRangeChange: (val: string[]) => void;
	rangeSize: number;
}

export const CalendarContext = React.createContext<ICalendarContext>({
	dateRange: [],
	handleDateRangeChange: (val: string[]) => {},
	rangeSize: 1,
});

export interface CalendarManagerProps {}

const CalendarManager: React.FC<CalendarManagerProps> = ({ children }) => {
	// Theme
	const theme = useTheme();
	const matchXs = useMediaQuery(theme.breakpoints.down("xs"));
	const matchSm = useMediaQuery(theme.breakpoints.down("sm"));

	// States
	const [dateRange, setDateRange] = React.useState<string[]>([
		moment().format(DateTime.DEFAULT_DATE_FORMAT),
		moment().add(1, "day").format(DateTime.DEFAULT_DATE_FORMAT),
		moment().add(2, "day").format(DateTime.DEFAULT_DATE_FORMAT),
	]);
	const [rangeSize, setRangeSize] = React.useState<number>(3);

	// Effects
	React.useEffect(() => {
		const dates = Calendar.generateDateRangeFrom(
			moment().format(DateTime.DEFAULT_DATE_FORMAT),
			rangeSize
		);
		setDateRange(dates);
	}, [rangeSize]);

	React.useLayoutEffect(() => {
		setRangeSize(matchXs ? 1 : matchSm ? 2 : 3);
	}, [matchSm, matchXs]);

	// Handlers
	const handleDateRangeChange = React.useCallback((val: string[]) => {
		setDateRange(val);
	}, []);

	React.useEffect(() => {
		// Utility.debug(dateRange);
	}, [dateRange]);

	return (
		<CalendarContext.Provider
			value={{ dateRange, handleDateRangeChange, rangeSize }}
		>
			{children}
		</CalendarContext.Provider>
	);
};

export const useCalendarManager = () => React.useContext(CalendarContext);

export default CalendarManager;
